import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import MaterialsCategoriesDt from '@/services/dataTransferModules/materialsCategoriesDt'

export default function useMaterialsCategories() {
	const materialsCategoriesDt = new MaterialsCategoriesDt()

	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		createEntity: createMaterialsCategories,

		entities: materialsCategories,
		getEntities: getMaterialsCategories,

		entityPreview: materialsCategoriesPreview,
		getEntityPreview: getMaterialsCategoriesPreview,

		entity: materialsCategory,
		getEntity: getMaterialsCategory,

		hashedEntities: materialsCategoriesHashed,
		getHashedEntities: getMaterialsCategoriesHashed,

		patchEntity: updateMaterialsCategories,
		updateEntity: fullUpdateMaterialsCategories,

		deleteEntity: deleteMaterialsCategories,

	} = useBlProviders(materialsCategoriesDt,
		{
			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Materials categories loaded with an error!'),

			showErrorNotificationForCreatingEntity: true,

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Error when editing materials category'),

			showErrorNotificationForDeletingEntity: true,
		}
	)

	return {
		flags,
		materialsCategories,
		materialsCategoriesPreview,
		materialsCategory,
		materialsCategoriesHashed,
		getMaterialsCategories,
		getMaterialsCategoriesPreview,
		getMaterialsCategory,
		getMaterialsCategoriesHashed,
		updateMaterialsCategories,
		fullUpdateMaterialsCategories,
		createMaterialsCategories,
		deleteMaterialsCategories,
	}
}
